import React, {useMemo} from 'react';
import {SmallHeader, SmallLogo} from "../styles/globalStyles";
import {getBoxLogoReplacement, onLinkClicked} from "../helpers/functions";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import useScreenSize from "../helpers/hooks/useScreenSize";

const Logo = (props) => {
    const {onClick} = props;
    const box = useSelector(state => state.site.box)
    const loggedIn = useSelector(state => state.auth.loggedIn)
    const name = useMemo(() => box ? getBoxLogoReplacement(box.name) : '', [box]);
    const navigate = useNavigate();
    const {isMobile} = useScreenSize();

    if(!box) return <></>

    const onLogoClick = () => {
        if(loggedIn) return
        onLinkClicked('/', navigate)
        if(onClick) onClick()
    }

    return (
        <>
            {
                box.cloudinary_image ?
                    <SmallLogo mobile={isMobile} loggedIn={loggedIn} src={box?.cloudinary_image} alt="logo" onClick={onLogoClick}/>
                    :
                    <div onClick={onLogoClick}><SmallHeader fontSize={'22px'}>{name}</SmallHeader></div>
            }
        </>
    )
};

export default Logo;